<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Customers" searchable="true"></crud-nav-header>

            <div class="grouping-key-container">
                <a v-for="(theList,groupingKey) in items" @click.prevent="scrollContainerTo(groupingKey)" href="#">{{
                    groupingKey }}</a>
            </div>

            <crud-nav-scroll>
                <div class="grouped-item-listings" v-for="(theList,groupingKey) in items">
                    <h2>{{ groupingKey }}</h2>
                    <span class="hide-me-please" :id="'item-list-group-heading-'+groupingKey"></span>

                    <ul>
                        <li v-for="customer in theList" class="items-list-item" :class="{active: isCurrentItem(customer) }">
                            <div class="name">
                                <a href="#" @click.prevent="viewItem(customer)">{{ customer.name }}<span v-if="customer.amount_owed != '0.00'" class="amount-owed">They owe £{{ customer.amount_owed }}</span></a>
                            </div>
                        </li>
                    </ul>
                </div>

            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New Customer" can-go-back-to-nav="true"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <v-select :on-search="getPeopleAndCompanies" v-model="new_item"
                          placeholder="Create customer from a person or company..."
                          :options="peopleAndCompanies">
                    <span slot="no-options">Start typing to find people or companies.</span>
                </v-select>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss hidden-desktop" @click.prevent="backToNav()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" v-if="!newCustomerExists" class="action-button action-button-success"
                       @click.prevent="addItem()">
                        <i class="fa fa-plus-square-o" aria-hidden="true"></i> Create Customer
                    </a>
                </div>

            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing: '+current_item.name" can-delete="true" can-edit="true"
                                  can-go-back="true" :item="current_item"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Name</dt>
                    <dd>{{ current_item.name }}</dd>
                    <dt>Bank Name</dt>
                    <dd><input type="text" v-model="current_item.bank_name"/></dd>
                    <dt>Account Number</dt>
                    <dd><input type="text" v-model="current_item.account_no"/></dd>
                    <dt>Sort Code</dt>
                    <dd><input type="text" v-model="current_item.sort_code"/></dd>
                    <dt>Limit Date</dt>
                    <dd><input type="date" v-model="current_item.limit_date"/></dd>
                    <dt>Credit Score</dt>
                    <dd><input type="text" v-model="current_item.credit_score"/></dd>
                    <dt>Credit Limit</dt>
                    <dd><input type="text" v-model="current_item.credit_limit"/></dd>
                    <dt>UTR</dt>
                    <dd><input type="text" v-model="current_item.utr"/></dd>
                    <dt>Company Registration</dt>
                    <dd><input type="text" v-model="current_item.co_registration"/></dd>
                    <dt>VAT Registration</dt>
                    <dd><input type="text" v-model="current_item.vat_registration"/></dd>
                </dl>
                <hr/>
                <dl>
                    <dt>Customer Type</dt>
                    <dd>
                        <label class="inline-radio-label">None</label><input class="inline-radio-input" type="radio"
                                                                             value=""
                                                                             v-model="current_item.customer_type"/>
                        <label class="inline-radio-label">Pro-Forma</label><input class="inline-radio-input"
                                                                                  type="radio" value="Pro-Forma"
                                                                                  v-model="current_item.customer_type"/>
                        <label class="inline-radio-label">Credit</label><input class="inline-radio-input" type="radio"
                                                                               value="Credit"
                                                                               v-model="current_item.customer_type"/>
                    </dd>
                    <dt>Default Account Code</dt>
                    <dd>
                        <v-select v-model="current_item_ac"
                                  placeholder="Choose an account type that this customer is linked to."
                                  :options="account_codes"></v-select>
                    </dd>


                    <dt>Default Payment Terms</dt>
                    <dd><input type="text" v-model="current_item.default_payment_terms"/></dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update Customer
                    </a>
                </div>

            </crud-edit>
            <crud-view>
                <crud-main-header :title="current_item.name" can-delete="true" can-edit="true" can-go-back-to-nav="true"
                                  :item="current_item"></crud-main-header>

                <tab-list>
                    <tab name="Overview" active="true">
                        <dl>
                            <dt>Name</dt>
                            <dd>{{ current_item.name }}</dd>
                            <dt>Bank Name</dt>
                            <dd>{{ current_item.bank_name }}</dd>
                            <dt>Account Number</dt>
                            <dd>{{ current_item.account_no }}</dd>
                            <dt>Sort Code</dt>
                            <dd>{{ current_item.sort_code }}</dd>
                            <dt>Limit Date</dt>
                            <dd>{{ current_item.limit_date }}</dd>
                            <dt>Credit Score</dt>
                            <dd>{{ current_item.credit_score }}</dd>
                            <dt>Credit Limit</dt>
                            <dd>{{ current_item.credit_limit }}</dd>
                            <dt>UTR</dt>
                            <dd>{{ current_item.utr }}</dd>
                            <dt>Company Registration</dt>
                            <dd>{{ current_item.co_registration }}</dd>
                            <dt>VAT Registration</dt>
                            <dd>{{ current_item.vat_registration }}</dd>
                        </dl>
                        <hr/>
                        <dl>
                            <dt>Customer Type</dt>
                            <dd>{{ current_item.customer_type }}</dd>
                            <dt>Default Account</dt>
                            <dd>{{ current_item.default_account_type }}</dd>
                            <dt>Default Payment Terms</dt>
                            <dd>{{ current_item.default_payment_terms }}</dd>
                        </dl>
                    </tab>
                    <tab name="People">
                        <div v-for="person in current_item.people" class="people-block">
                            <dl>
                                <dt>Name</dt>
                                <dd>{{ person.name }}</dd>
                                <dt>Position</dt>
                                <dd>{{ person.position }}</dd>
                                <dt>Email</dt>
                                <dd><a :href="'mailto:'+person.email">{{ person.email }}</a></dd>
                                <dt>Telephone</dt>
                                <dd><a :href="'tel:'+person.phone">{{ person.phone }}</a></dd>
                            </dl>
                        </div>
                    </tab>
                    <tab name="Sales Invoices">
                        <sales-invoices-list compact="true" :client-type="current_item.customer_type"
                                             :client-id="current_item.customer_id"></sales-invoices-list>
                    </tab>
                    <tab name="Sales Orders">
                        <sales-orders-list compact="true" :client-type="current_item.customer_type"
                                           :client-id="current_item.customer_id"></sales-orders-list>
                    </tab>
                </tab-list>

            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    import vSelect from "vue-select";

    export default {
        components: {
            vSelect
        },
        data() {
            return {
                name: 'customers',
                items: [],
                current_item: {},
                current_item_ac: {},
                account_codes: [],
                new_item: null,
                nextPaginationUrl: '',
                peopleAndCompanies: [],
                newCustomerExists: false,
                search_query: '',
                errors: null
            }
        },
        watch: {
            "new_item": function (item) {

                if (_.isObject(item) && item.exists) {
                    this.errors = {customer: ['This customer already exists in the customer list.']};
                    this.newCustomerExists = true;
                    return;
                }

                this.errors = null;
                this.newCustomerExists = false;
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            customerAlreadyExists: function (type, id) {
                var exists = false;


                _.forEach(this.items, function (customer) {
                    if (customer.customer_type == type && parseInt(customer.customer_id, 10) == parseInt(id, 10)) {
                        exists = true;
                    }
                });

                return exists;
            },
            getPeopleAndCompanies: _.debounce(function (search, loading) {
                var that = this;

                if (!search) {
                    return;
                }

                loading(true);
                that.peopleAndCompanies = [];
                axios.get(appUrls.customers.options, {params: {'query': search}})
                    .then(response => {
                        _.forEach(response.data.data, function (personOrCompany) {
                            that.peopleAndCompanies.push({
                                label: personOrCompany.name,
                                value: personOrCompany.type + '_' + personOrCompany.id,
                                exists: that.customerAlreadyExists(personOrCompany.raw_type, personOrCompany.id)
                            });
                        });
                        loading(false);
                    });
            }, 500),
            saveItem: function () {
                var that = this;
                var editingItem = $.extend({}, this.current_item);
                var formDataObject = new FormData();
                var saveUrl = appUrls.customers.update.replace('REPLACEME', editingItem.id);

                editingItem['default_account_code'] = this.current_item_ac.value;

                _.forIn(editingItem, function (value, key) {
                    formDataObject.append(key, value);
                });

                formDataObject.append('_method', 'put');

                axios.request({
                    method: 'post',
                    url: saveUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    that.getItems();
                    that.viewItem(response.data.data);

                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            deleteItem(itemToDelete) {
                var that = this;
                var title = 'Are you sure you want to remove ' + itemToDelete.name + ' as a customer?';
                var description = 'You are removing ' + itemToDelete.name + ' as a supplier. They can always be re-added. Are you sure you want to do this?';
                var standardCallback = function (itemToDelete) {
                    that.getItems();

                    eventBus.$emit('crud-show-new-' + that.name);
                    eventBus.$emit('crud-back-to-nav-' + that.name);
                };

                eventBus.$emit('delete-modal-open', title, description, function () {
                    axios.delete(appUrls.customers.destroy.replace('REPLACEME', itemToDelete.id));
                    standardCallback(itemToDelete);
                });
            },
            resetErrors() {
                this.errors = null;
            },
            addItem() {
                var that = this;

                var data = {
                    'type': this.new_item.value.split("_")[0],
                    'id': this.new_item.value.split("_")[1]
                };

                var addUrl = appUrls.customers.store;

                var standardCallback = function (item) {
                    that.getItems();
                    that.viewItem(item);

                };

                axios.request({
                    method: 'post',
                    url: addUrl,
                    data: data
                }).then(response => {
                    standardCallback(response.data.data);
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            scrollContainerTo: function (key) {
                var $relevantElement = $("#item-list-group-heading-" + key);
                console.log('Scrolling To: '+key,$relevantElement.offset().top);

                $('.crud-scroller').first().scrollTop(0);

                $('.crud-scroller').first().animate({
                    scrollTop: $relevantElement.offset().top - 180
                }, 500);
            },
            isCurrentItem: function (item) {
                if (!("id" in this.current_item)) {
                    return false;
                }

                return item.id === this.current_item.id;
            },
            // The Big Daddy Of Methods - Retrieves all methods.
            getItems() {
                var that = this;
                var url = appUrls.customers.index;
                var getVarName = 'customer';
                var params = {
                    group_by_letter: true
                };

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;
                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName(getVarName);
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            } else {
                                that.getAndViewItemById(idFromVariable);
                            }
                        }
                    });
            },
            getAndViewItemById(id) {
                var that = this;
                var url = appUrls.customers.show.replace('REPLACEME', id);

                axios.get(url)
                    .then(response => {
                        that.viewItem(response.data.data);
                    });
            },
            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            getAccountCodes() {
                var that = this;
                this.account_codes = [];
                var url = appUrls.account_codes.index;

                axios.get(url)
                    .then(response => {
                        _.forEach(response.data.data, function (ac) {
                            that.account_codes.push({
                                label: ac.name,
                                value: ac.id
                            });
                        });
                    });
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            }
        },
        mounted() {
            var that = this;

            this.getItems();
            this.getAccountCodes();

            window.eventBus.$on('crud-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('crud-search-hidden-' + this.name, function (query) {
                that.search_query = null;
                that.getItems();
            });

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });

            window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
                this.new_item = {};
                this.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.new_item = {};
                that.current_item = item;
                that.current_item_ac = {
                    label: item.default_account_type,
                    value: item.default_account_code
                };
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
                that.new_item = {};
                that.resetErrors();
            });
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';

    .inline-radio-label {
        margin-right: 5px;
        display: inline-block;
    }

    .inline-radio-input {
        margin-right: 15px;
    }

    .amount-owed{
        float:right;
        font-weight:500;
        opacity:0.5;
    }

    .people-block{
        padding:1em;
        border-radius: $standardBorderRadius;
        background-color: #f3f3f3;
        margin: 1em;
    }
</style>